import { render, staticRenderFns } from "./editiklan.vue?vue&type=template&id=3997ad03&"
import script from "./editiklan.vue?vue&type=script&lang=js&"
export * from "./editiklan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports